import type FacilityWorkflowView from '@UI/Store/FacilityWorkflows/Views/FacilityWorkflowView';
import type WorkflowRunSummaryView from '@UI/Store/WorkflowRuns/Views/WorkflowRunSummaryView';

/** Mirrors on screen the server's opening rule (`WorkflowRunOpener`): any change to that rule is made on both sides. */
const findBlockingPreparation = (
	preparations: readonly WorkflowRunSummaryView[],
	workflow: FacilityWorkflowView,
): WorkflowRunSummaryView | null => {
	const ofWorkflow = preparations.filter((preparation) => preparation.workflowKey === workflow.key);
	const toComplete = ofWorkflow.find((preparation) => preparation.isOpen);

	if (toComplete !== undefined) {
		return toComplete;
	}

	if (!workflow.requiresValidationBeforeNext) {
		return null;
	}

	return (
		ofWorkflow
			.filter(
				(preparation) => preparation.state.value === 'in_progress' && preparation.handledAt === null,
			)
			.sort((first, second) => second.openedAt.getTime() - first.openedAt.getTime())[0] ?? null
	);
};

export default findBlockingPreparation;
